import classNamesPackage from 'classnames'

type ClassNames = typeof classNamesPackage

export const kuiperClassNames: ClassNames = (...args) => {
  const classes = classNamesPackage(...args)
  return classes
    .split(/\s/)
    .map((cls) => {
      if (cls === '') return ''

      if (cls.startsWith('kuiper-') || cls.startsWith('tracking-')) {
        return cls
      }

      return `kuiper-${cls}`
    })
    .join(' ')
}

export const kuiperClassNamesWithTracking: ClassNames = (...args) => {
  let trackingClassName

  const newArgs = args.map((arg) => {
    if (arg !== null && typeof arg === 'object' && !Array.isArray(arg)) {
      if (arg.tracking) {
        trackingClassName = `tracking-${arg.tracking}`
        const newArg = { ...arg }
        delete newArg.tracking
        return newArg
      }
    }
    return arg
  })

  return kuiperClassNames([...newArgs, trackingClassName])
}
